import React, { useState } from 'react';
import { FaRegEyeSlash } from "react-icons/fa";

const AccountSettings: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('activepost');

  const handleTabChange = (tabName: string) => {
    setActiveTab(tabName);
  };

  return (
    <div className="my-5">
      <div className="container">
        <div className="d-flex flex-row align-items-center justify-content-between">
          <div className='js-mn-title flex-grow-1'>
            <h2 className='fw-bold pb-2'>Account Settings</h2>
            <p>Edit Profile and update change</p>
          </div>
        </div>

        {/* Tab Navigation */}
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'activepost' ? 'active' : ''}`}
              id="activepost-tab"
              onClick={() => handleTabChange('activepost')}
            >
              Edit Profile
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'inactivepost' ? 'active' : ''}`}
              id="inactivepost-tab"
              onClick={() => handleTabChange('inactivepost')}
            >
              Change Password
            </button>
          </li>
        </ul>

        <div className="tab-content row mb-5" id="myTabContent">
          <div
            className={`tab-pane col-lg-6 mt-4 fade ${activeTab === 'activepost' ? 'show active' : ''}`}
            id="activepost"
            role="tabpanel"
          >
            <div className="form-step fade-in">
              <div className="d-flex flex-row align-items-center mb-4 justify-content-between">
                <div className='js-mn-title flex-grow-1 mt-3'>
                  <h4 className='fs-5 pb-2 text-start'>Personal Information</h4>
                </div>
              </div>
              <div className="mb-4 text-start">
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  value="Madhav R"
                  className="form-control-custom"
                />
              </div>
              <div className="mb-4 text-start">
                <label className="form-label">Email Address</label>
                <input
                  type="email"
                  value="madhav.k@veritis.com"
                  className="form-control-custom"
                />
              </div>

              <div className="mb-4 text-start">
                <label className="form-label">Profile Image</label>
                <input
                  type="file"
                  className="form-control-custom"
                />
              </div>




              <div className='text-start'>
               <button type="button" className="btn mt-3 px-5 py-3 btn-outline-primary me-4">
                Cancel
               </button>
                <button type="button" className="btn mt-3 px-5 py-3 btn-primary">
                Update
                </button>

              </div>

            </div>
          </div>

          <div
            className={`tab-pane mt-4 col-lg-6 fade ${activeTab === 'inactivepost' ? 'show active' : ''}`}
            id="inactivepost"
            role="tabpanel"
          >
            <div className="d-flex flex-row align-items-center mb-4 justify-content-between">
              <div className='js-mn-title flex-grow-1 mt-3'>
                <h4 className='fs-5 pb-2 text-start'>Update Password</h4>
              </div>
            </div>
            <div className='mb-4 text-start'>
              <label className="form-label">New Password</label>
              <div className="input-group">
                <input
                  className="form-control-custom"
                  type="password"
                  placeholder="Enter your password"
                />

              </div>
            </div>
            <div className='mb-4 text-start'>
              <label className="form-label">Confirm Password</label>
              <div className="input-group mb-4">
                <input
                  className="form-control-custom m-0"
                  type="password"
                  placeholder="Enter your password"
                />
   
              </div>
            </div>

            <div className='text-start'>
               <button type="button" className="btn mt-3 px-5 py-3 btn-primary">
              Update
               </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;
